export const softText = [
"We offer a full range of software development services for each & every business domain. If you are a start-up or an established company, we are here to assist with solutions at every stage of your software development lifecycle, whether it is from the ground up development, proof of concept work, or helping maintain an existing application.",
"Our business analysts and developers are experts that work with you every step of the process as a dedicated team to solve your most complex problems. Our team provides round-the-clock critical support to drive the value of your business.",
"With over a decade of experience behind us, we have built up expertise in most of the common programming languages. We blend latest methodologies with innovations to build a one stop solution. Our application frameworks: ",
]
export  const softTestList = [
"ColdFusion",
"Full Stack JavaScript",
"Python",
".NET",
"PHP",
]
export const softText2 =[
    "There are several factors to consider when putting a technology stack together including cost of the software and availability of professionals to support your project. We assist our clients in determining the right programming stack and test automation framework that best meets their project and business goals. We focus our recommendations and solutions not just on the ability to deliver quickly, but the cost of supporting the solution in the future. Our years of experience have also exposed us to many business domains such as retail, media, and education. Our experience with past projects in these domains helps us address client's needs in quick turn arounds."
]

export const jsFullStack = [
"Every business needs the professionals who have got extensive knowledge about everything right from the backend to frontend. So, most of them tend to hire the full stack web developer who has got server & frontend development skills and who are specialized in everything; the entire process right from the concept and ideation step to the finished product.",
"At IStellar we have expert developers who has vast experience in Full-stack coding and deployment. Our clients trust us as leading Full Stack Development Company.",
"Our full stack development services includes MERN/MEAN stack and all other types of development. We are specialized in"
]
export const jsFullStackList = [
"NodeJS",
"ReactJS",
"Angular",
"VueJS",
"BackboneJS",
]
export const jsFullStackImg = [
"jsFullStackImg1",
]

export const Microsoft = [
"Microsoft brings the most powerful, functional, and robust technology solutions and platforms with a familiar user interface for ease of adoption and seamless integration.",
"IStellar helps you to deploy individual Microsoft products, but also helps you develop and integrate a wide range of applications, such as mobile apps, desktop applications, custom software solutions, web solutions and more.",
]
export const MicrosoftList = [
"Application Development",
"Application Integration",
"Mobile Services",
"Application Support & Maintenance",
"Product Engineering",
]

export const MicrosoftImg = [
"MicrosoftImg1",
"MicrosoftImg2",
]
export const MicrosoftTable = [{
    "col1" : "Architecture",
    "col2" : "MVC, MVVM, n-tier, Microservices",
    }, {
    "col1" : "Database",
    "col2" : "MS SQL Server, Hadoop, MongoDB, Oracle, Postgress",
    }, {
    "col1" : "BI / Reporting Tools",
    "col2" : "SSAS, SSIS, SSRS",
    }, {
    "col1" : "Platforms",
    "col2" : ".NET Framework, ASP.NET Core, .NET MVC Framework",
    }, {
    "col1" : "Languages",
    "col2" : "C#, ASP.NET, VB.NET",
    }, {
    "col1" : "Web Services",
    "col2" : "WCF, ASMX, WebApi",
    }, {
    "col1" : "Scripts",
    "col2" : "jQuery, Angular",
    }, {
    "col1" : "Cloud Services",
    "col2" : "Microsoft Azure, Amazon Web Services",
    },
]

export const Database = [
"NoSQL is the hot choice for database development currently. However, the decision for SQL or NoSQL needs to be done based on the needs of the project and not the desires of the development team. For many projects, there is a need for both. We help our clients determine the best DB for their project and help implement the chosen solution.",
"In the NoSQL space, we work with MongoDB, DynamoDB, Cassandra. For SQL DB's we work with MySQL, Postgres and Microsoft SQL Server. For 'Big Data' projects, we work with Amazon Web Service Redshift for setting up Data Warehousing for the many benefits this solution provides in terms of pricing, scale and availability.",
]

export const Contact = [
"If you have small ad-hoc task or bigger team project or your dream product idea in software development ( ColdFusion / NodeJS / ReactJS / Angular / VueJS / .NET Core / WebAPI / C# / AWS / Azure), please don't hesitate to keep in touch with us.",
"To discuss about our software development expertise and services, please mail us on business@istellar.com or call +1 (817) 606-6969 / +91 6969696969",
]